import './TeamsSearch.scss'

import {
	FieldsubmitField,
	FieldsubmitRow,
	FieldsubmitSubmit
} from '../../ui/Fieldsubmit'
import {FormProvider, useForm} from 'react-hook-form'
import {ImageType, PageData, WysiwygType} from '../../../types'
import {Input, Label} from '../../layout/Form'
import React, {useEffect, useState} from 'react'
import {TeamCardType, TeamsOverview} from './TeamsOverview'

import {EntryData} from '../../../campagne/types'
import {Errors} from '../../layout/form/Errors'
import {LoadingIcon} from '../../ui/LoadingIcon'
import {Theme} from '../../Theme'
import {fetcher} from '../../../util/fetcher'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('teamssearch')

export type TeamsSearchType = {
	editionId?: number
}

export type TeamMemberType = EntryData & {
	firstname: string
	lastname: string
}

export type TeamType = {
	team: TeamMemberType
	team_image: ImageType
	team_description: WysiwygType
} & PageData

export const TeamsSearch: React.FC<TeamsSearchType> = ({editionId}) => {
	const t = useTranslation('teams')
	const methods = useForm()
	const [teams, setTeams] = useState<Array<TeamCardType>>([])
	const [isLoading, setLoading] = useState(true)
	const {handleSubmit, getValues} = methods

	const onSubmit = () => searchTeam()

	const fieldsubmit = {
		type: 'search',
		name: 'search',
		id: 'search',
		label: t.search_label
	}

	const searchTeam = () => {
		fetcher(
			`/api/teams?query=${getValues(fieldsubmit.name)}&editionId=${editionId}`
		).then((data: Array<TeamCardType>) => {
			setLoading(false)
			setTeams(data)
		})
	}

	useEffect(() => {
		searchTeam()
	}, [])

	const hasTeams = teams && teams?.length > 0

	return (
		<div className={styles()}>
			<FormProvider {...methods}>
				<form onSubmit={handleSubmit(onSubmit)} className={styles('form')}>
					<Theme.Container>
						<FieldsubmitRow>
							<FieldsubmitField>
								<Label
									htmlFor={fieldsubmit.id || fieldsubmit.name}
									label={fieldsubmit.label}
								/>
								<Input
									{...fieldsubmit}
									id={fieldsubmit.id || fieldsubmit.name}
								/>
							</FieldsubmitField>
							<FieldsubmitSubmit nomargin={true}>
								<Theme.Button
									loading={isLoading}
									as="button"
									className={styles('form-submit')}
								>
									{t.search}
								</Theme.Button>
							</FieldsubmitSubmit>
						</FieldsubmitRow>
						<Errors />
					</Theme.Container>
				</form>
			</FormProvider>
			{!isLoading && hasTeams && (
				<TeamsOverview items={teams} query={getValues(fieldsubmit.name)} />
			)}
			{(isLoading || !hasTeams) && (
				<div className={styles('status')}>
					<Theme.Container>
						{isLoading && (
							<div className={styles('status-loading')}>
								<LoadingIcon />
							</div>
						)}
						{!hasTeams && !isLoading && (
							<p className={styles('status-empty')}>{t.search_empty}</p>
						)}
					</Theme.Container>
				</div>
			)}
		</div>
	)
}
